import { P2GTab, P2GTabs } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RoutingConstantsLabels } from '~/apps/smartsend/lib/consts/RoutingConstants';
import useGoto from '~/hooks/use-goto';
import useSmartNav from '~/hooks/use-smart-nav';
import { TranslationNamespaces } from '~/lib/constants';

const sanitisedRoute = (route: string) =>
  route
    .replace(/\/:.*$/, '')
    .replace(/[-/]/g, '')
    .toUpperCase();

const Navvy = ({ routes, prefix }: { routes: string[]; prefix: string }) => {
  const { currentPageRoute } = useSmartNav();
  const { t } = useTranslation(TranslationNamespaces.MYACCOUNT);
  const { goTo } = useGoto();

  const links = useMemo(
    () =>
      routes.map((r) => ({
        route: r,
        label: t(`NAV_${prefix}_${sanitisedRoute(r)}_LINK`.toUpperCase(), RoutingConstantsLabels[r] || r)
      })),
    [t, routes, prefix]
  );

  const currentIndex = useMemo(() => {
    const index = links.findIndex((link) => link.route === currentPageRoute);
    return index >= 0 ? index : 0;
  }, [links, currentPageRoute]);

  if (links.length <= 1) {
    return null;
  }

  return (
    <P2GTabs value={currentIndex}>
      {links.map((link, index) => (
        <P2GTab key={link.route} label={link.label} onClick={() => goTo(link.route)} index={index} />
      ))}
    </P2GTabs>
  );
};

export default Navvy;
